import React from "react"
import { COPY } from "../config/copy"
import type { Product } from "../types/product"

interface ResultsScreenProps {
  product: Product
}

function formatTemperature(value: number | null): string {
  if (value === null) {
    return ""
  }

  return `${value >= 0 ? "+" : ""}${value}°C`
}

function getDisplayedTemperatureRanges(product: Product) {
  if (Array.isArray(product.tempRangesC) && product.tempRangesC.length > 0) {
    return product.tempRangesC
  }

  return [product.tempRangeC]
}

export function ResultsScreen({
  product,
}: ResultsScreenProps): JSX.Element {
  const temperatureRanges = getDisplayedTemperatureRanges(product)

  return (
    <section className="csw-results" aria-live="polite">
      <div className="csw-results-head">
        <h2 className="@max-5xl:border-b-2 @max-5xl:pb-[10px]">
          {COPY.results.heading}
        </h2>
      </div>

      <div className="csw-spec-table">
        <div className="csw-spec-row">
          <span className="csw-spec-label">Description</span>
          <span className="csw-spec-value">{product.description}</span>
        </div>
        <div className="csw-spec-row">
          <span className="csw-spec-label">Sizes (in Liters)</span>
          <span className="csw-spec-value">{product.sizesLiters}</span>
        </div>
        <div className="csw-spec-row">
          <span className="csw-spec-label">Temperature Ranges</span>
          <div
            className="csw-temp-range-table"
            role="table"
            aria-label="Temperature ranges"
          >
            <div className="csw-temp-range-head" role="row">
              <span role="columnheader">MIN</span>
              <span role="columnheader">MAX</span>
            </div>
            {temperatureRanges.map((range, index) => (
              <div
                key={`${product.slug}-temp-range-${index}`}
                className="csw-temp-range-row"
                role="row"
              >
                <span role="cell">{formatTemperature(range.min)}</span>
                <span role="cell">{formatTemperature(range.max)}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="csw-spec-row">
          <span className="csw-spec-label">Duration (in hours)</span>
          <span className="csw-spec-value">{product.maxDurationH}</span>
        </div>
      </div>

    </section>
  )
}
